export default __webpack_public_path__ + "static/media/2020-06_Chatbots1.aaa6c1b7.jpg";